import { Loader2, AlertTriangle, Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LoadingState({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-slate-400" data-testid="loading-state">
      <Loader2 className="w-6 h-6 animate-spin mb-3 text-violet-400" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="error-state">
      <div className="w-12 h-12 rounded-full bg-rose-500/10 border border-rose-500/30 flex items-center justify-center mb-4">
        <AlertTriangle className="w-5 h-5 text-rose-400" />
      </div>
      <p className="text-sm text-slate-300 mb-4 max-w-md">{message || "Something went wrong."}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry} data-testid="error-retry-button">Try again</Button>
      )}
    </div>
  );
}

export function EmptyState({ title, description, action, icon: Icon = Inbox, testid = "empty-state" }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid={testid}>
      <div className="w-14 h-14 rounded-2xl bg-slate-800/60 border border-slate-700/60 flex items-center justify-center mb-4">
        <Icon className="w-6 h-6 text-slate-400" />
      </div>
      <h3 className="text-lg font-display font-semibold text-slate-100 mb-1.5">{title}</h3>
      {description && <p className="text-sm text-slate-400 max-w-md mb-5">{description}</p>}
      {action}
    </div>
  );
}
